interface AdsenseConfig {
  clientId: string;
  squareId?: string;
  verticalId?: string;
}
interface ThemeConfig {
  color: {
    primary: string;
  };
}

export const ADSENSE_CONFIG: AdsenseConfig = JSON.parse(
  import.meta.env.VITE_ADSENSE_CFG || "{}",
);

export const THEME_CONFIG: ThemeConfig = JSON.parse(
  import.meta.env.VITE_THEME_CFG || "{}",
);
